var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 3a5 5 0 1 0 0 10A5 5 0 0 0 8 3M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m5.635-3.527A2.333 2.333 0 0 1 8.5 9.057v.165a.5.5 0 1 1-1 0v-.611a.5.5 0 0 1 .5-.5 1.333 1.333 0 1 0-1.268-1.745.5.5 0 1 1-.951-.309 2.33 2.33 0 0 1 1.854-1.584m-.165 6.583a.5.5 0 0 1 .5-.5h.06a.5.5 0 0 1 .5.5v.06a.5.5 0 0 1-.499.5h-.06a.5.5 0 0 1-.501-.5z",
    clipRule: "evenodd"
  })));
};
export { SvgHelp as ReactComponent };
export default __webpack_public_path__ + "6f4a270dd9600cffcd897445ae55a81b.svg";